/**
 *
 *
 */
export type PromiseOptions = {
  /**
 *
 *
 *
 */
  timeout?: number;
  /**
 *
 *
 */
  signal?: AbortSignal;

  /**
 *
 *
 */
  message?: string;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const withPromise = <T>(promise: Promise<T>, options: PromiseOptions): Promise<T> => {
  const { timeout, signal, message = "Promise resolution failed" } = options;
  const races: PromiseLike<T>[] = [promise];

  if (timeout) {
    races.push(
      new Promise((_, reject) => {
        setTimeout(() => {
          reject(Error(`${message}. Wait exceeded configured timeout: ${timeout}`));
        }, timeout);
      }),
    );
  }

  if (signal) {
    races.push(
      new Promise((_, reject) => {
        signal.addEventListener("abort", () => {
          reject(Error(`${message}. Wait cancelled due to abort signal: ${signal.reason}`));
        });
      }),
    );
  }

  return Promise.race(races);
};
